import React from "react";

const AppInfo = () => {
  return (
    <article
      className="mt-5 pt-5"
      style={{
        borderTop: "1px solid #dee2e6",
        lineHeight: "1.8",
      }}
    >
      <h2 className="h5 mb-2">What is K.I.E.I?</h2>
      <p className="text-muted mb-3">
        The Kundu Introversion Extraversion Inventory (K.I.E.I) is a
        scientifically validated personality test specifically designed for the
        Indian socio-cultural context. Developed by Dr. Ramanath Kundu at the
        University of Calcutta in 1976, this assessment tool recognizes that
        Western personality tests often fail to capture the unique behavioral
        patterns and social dynamics of Indian individuals.
      </p>
      <p className="text-muted mb-3">
        Unlike popular tests like the Myers-Briggs Type Indicator (MBTI) that
        force you into binary categories, the K.I.E.I places you on a
        continuous spectrum. Rather than simply labeling you as an "introvert" or
        "extrovert," this personality assessment reveals your exact position on
        the spectrum. This includes identifying if you fall into the important
        middle ground of "Ambiversion," which is where most people actually
        reside according to personality research.
      </p>

      <h2 className="h5 mt-4 mb-2">Why K.I.E.I is Different</h2>
      <p className="text-muted mb-3">
        Have you ever taken a personality test and felt like the questions
        didn't quite fit your reality? That's because most personality
        assessments were created in Western countries and assume cultural norms
        that don't always apply in India. The K.I.E.I was built from the
        ground up using Indian social contexts, behaviors, and values.
      </p>
      <p className="text-muted mb-3">
        For example, in Indian culture, showing respect through silence in the
        presence of elders is a sign of good upbringing, not social anxiety.
        The K.I.E.I understands these nuances and measures your personality
        traits accurately within your cultural framework. This makes it one of
        the most reliable introvert vs extrovert tests for Indian students,
        professionals, and anyone seeking genuine self-understanding.
      </p>

      <h2 className="h5 mt-4 mb-2">Understanding Your Results</h2>
      <p className="text-muted mb-3">
        The K.I.E.I assessment consists of 70 carefully crafted questions that
        take about 30 minutes to complete. Your responses are analyzed using a
        sophisticated scoring system that considers not just what you answer,
        but how you answer across different types of questions.
      </p>
      <p className="text-muted mb-3">
        Your final score places you in one of 11 categories, ranging from
        "Extremely Extravert" to "Extremely Introvert," with the middle ranges
        representing various degrees of Ambiversion. Most people discover they
        are Ambiverts who can be social and outgoing when needed while also
        valuing quiet time for reflection and recharge. This balanced approach
        to personality is actually the norm, not the exception, making the
        KIEI test particularly valuable for understanding the full spectrum of
        human behavior.
      </p>

      <h2 className="h5 mt-4 mb-2">Who Can Benefit from This Test?</h2>
      <p className="text-muted mb-3">
        Students choosing their career stream, professionals considering job
        changes, or anyone curious about their personality can benefit from the
        K.I.E.I assessment. The results help you understand your natural
        preferences, how you interact with others, and what environments help
        you thrive. Whether you're planning your career path, improving your
        relationships, or simply exploring self-awareness, this test provides
        reliable, culturally relevant insights.
      </p>

      <h2 className="h5 mt-4 mb-2">Scientifically Validated and Private</h2>
      <p className="text-muted mb-3">
        The K.I.E.I has been extensively tested for reliability and validity,
        with research showing strong consistency and accuracy. Unlike many
        online personality quizzes, this is a genuine psychometric instrument
        used by psychologists and researchers.
      </p>
      <p className="text-muted">
        This digital version of the K.I.E.I assessment is brought to you by
        WizAmit. Your privacy is completely protected because all scoring
        happens locally in your browser, and no personal data is stored or
        shared. You can take this free personality test with complete confidence,
        knowing your responses remain private while you gain valuable insights
        into your personality type and behavioral patterns.
      </p>
    </article>
  );
};

export default AppInfo;

